import { NavLink, useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useTheme } from '../contexts/ThemeContext';
import { DayritLogo, LogoText } from './ui';
import { PomodoroTrigger } from './PomodoroTimer';

function TodayIcon()    { return <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>; }
function ChartIcon()    { return <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="20" x2="18" y2="10"/><line x1="12" y1="20" x2="12" y2="4"/><line x1="6" y1="20" x2="6" y2="14"/></svg>; }
function TagIcon()      { return <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M20.59 13.41l-7.17 7.17a2 2 0 01-2.83 0L2 12V2h10l8.59 8.59a2 2 0 010 2.82z"/><line x1="7" y1="7" x2="7.01" y2="7"/></svg>; }
function HabitIcon()    { return <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M12 2c0 0-4 4-4 8a4 4 0 008 0c0-2-1-4-1-4s-1 2-3 2c-1 0-2-1-2-2 0-2 2-4 2-4z"/><line x1="12" y1="14" x2="12" y2="22"/><line x1="9" y1="19" x2="15" y2="19"/></svg>; }
function SettingsIcon() { return <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.65 1.65 0 00.33 1.82l.06.06a2 2 0 010 2.83 2 2 0 01-2.83 0l-.06-.06a1.65 1.65 0 00-1.82-.33 1.65 1.65 0 00-1 1.51V21a2 2 0 01-4 0v-.09A1.65 1.65 0 009 19.4a1.65 1.65 0 00-1.82.33l-.06.06a2 2 0 01-2.83-2.83l.06-.06A1.65 1.65 0 004.68 15a1.65 1.65 0 00-1.51-1H3a2 2 0 010-4h.09A1.65 1.65 0 004.6 9a1.65 1.65 0 00-.33-1.82l-.06-.06a2 2 0 012.83-2.83l.06.06A1.65 1.65 0 009 4.68a1.65 1.65 0 001-1.51V3a2 2 0 014 0v.09a1.65 1.65 0 001 1.51 1.65 1.65 0 001.82-.33l.06-.06a2 2 0 012.83 2.83l-.06.06A1.65 1.65 0 0019.4 9a1.65 1.65 0 001.51 1H21a2 2 0 010 4h-.09a1.65 1.65 0 00-1.51 1z"/></svg>; }
function MoonIcon()     { return <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M21 12.79A9 9 0 1111.21 3 7 7 0 0021 12.79z"/></svg>; }
function SunIcon()      { return <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="5"/><line x1="12" y1="1" x2="12" y2="3"/><line x1="12" y1="21" x2="12" y2="23"/><line x1="4.22" y1="4.22" x2="5.64" y2="5.64"/><line x1="18.36" y1="18.36" x2="19.78" y2="19.78"/><line x1="1" y1="12" x2="3" y2="12"/><line x1="21" y1="12" x2="23" y2="12"/><line x1="4.22" y1="19.78" x2="5.64" y2="18.36"/><line x1="18.36" y1="5.64" x2="19.78" y2="4.22"/></svg>; }
function LogoutIcon()   { return <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/></svg>; }

const NAV_AUTHED = [
  { to: '/app',            Icon: TodayIcon,    label: 'Today'      },
  { to: '/app/analytics',  Icon: ChartIcon,    label: 'Analytics'  },
  { to: '/app/categories', Icon: TagIcon,      label: 'Categories' },
  { to: '/app/habits',     Icon: HabitIcon,    label: 'Habits'     },
  { to: '/app/settings',   Icon: SettingsIcon, label: 'Settings'   },
];

const NAV_GUEST = [
  { to: '/app',        Icon: TodayIcon, label: 'My Tasks' },
  { to: '/app/habits', Icon: HabitIcon, label: 'Habits'   },
];

function NavItem({ to, Icon, label, onClose }) {
  return (
    <NavLink to={to} end={to === '/app'} onClick={onClose}
      style={{ textDecoration: 'none', display: 'block', marginBottom: 1 }}>
      {({ isActive }) => (
        <div style={{
          display: 'flex', alignItems: 'center', gap: 10,
          padding: '8px 10px', borderRadius: 8,
          background: isActive ? 'var(--accent-light)' : 'transparent',
          color: isActive ? 'var(--accent)' : 'var(--text2)',
          fontWeight: isActive ? 600 : 400,
          fontSize: 13.5, cursor: 'pointer', transition: 'all 0.12s',
        }}
          onMouseEnter={e => { if (!isActive) e.currentTarget.style.background = 'var(--hover)'; }}
          onMouseLeave={e => { if (!isActive) e.currentTarget.style.background = 'transparent'; }}
        >
          <span style={{ display: 'flex', flexShrink: 0, opacity: isActive ? 1 : 0.55, color: isActive ? 'var(--accent)' : 'inherit' }}>
            <Icon />
          </span>
          {label}
        </div>
      )}
    </NavLink>
  );
}

export default function Sidebar({ onClose, hideHeader = false }) {
  const { user, logout } = useAuth();
  const { dark, toggleDark } = useTheme();
  const navigate = useNavigate();

  const isGuest = !user;
  const NAV = isGuest ? NAV_GUEST : NAV_AUTHED;

  const initials = user?.name
    ? user.name.split(' ').filter(Boolean).map(n => n[0]).join('').slice(0, 2).toUpperCase()
    : '?';

  const handleLogout = async () => { await logout(); navigate('/login'); };

  return (
    <aside style={{
      width: 220, flexShrink: 0,
      height: '100vh', position: 'sticky', top: 0,
      background: 'var(--sidebar-bg)',
      borderRight: '1px solid var(--border)',
      display: 'flex', flexDirection: 'column',
    }}>

      {/* Logo — hidden in mobile drawer (topbar already shows it) */}
      {!hideHeader && <div style={{ padding: '15px 14px 13px', borderBottom: '1px solid var(--border)', flexShrink: 0 }}>
        <Link to="/" style={{ display: 'inline-flex', alignItems: 'center', gap: 8, textDecoration: 'none' }}>
          <DayritLogo size={26} />
          <LogoText size={16} />
        </Link>
      </div>}

      {/* Nav */}
      <nav style={{ flex: 1, padding: '8px 8px 0', overflowY: 'auto' }}>
        {NAV.map(({ to, Icon, label }) => (
          <NavItem key={to} to={to} Icon={Icon} label={label} onClose={onClose} />
        ))}
      </nav>

      {/* Footer — single border, all utilities inside */}
      <div style={{ borderTop: '1px solid var(--border)', padding: '8px 8px 12px', flexShrink: 0 }}>

        {/* Pomodoro */}
        <PomodoroTrigger />

        {/* Thin rule between pomodoro and dark mode */}
        <div style={{ height: 1, background: 'var(--divider)', margin: '5px 4px 5px' }} />

        {/* Dark / light toggle */}
        <button onClick={toggleDark} style={{
          width: '100%', display: 'flex', alignItems: 'center', gap: 10,
          padding: '8px 10px', borderRadius: 8, marginBottom: 4,
          background: 'transparent', border: 'none', cursor: 'pointer',
          color: 'var(--text2)', fontSize: 13.5, fontFamily: 'inherit',
          transition: 'background 0.12s',
        }}
          onMouseEnter={e => e.currentTarget.style.background = 'var(--hover)'}
          onMouseLeave={e => e.currentTarget.style.background = 'transparent'}
        >
          <span style={{ display: 'flex', flexShrink: 0, opacity: 0.55 }}>
            {dark ? <SunIcon /> : <MoonIcon />}
          </span>
          {dark ? 'Light mode' : 'Dark mode'}
        </button>

        {/* User row */}
        {isGuest ? (
          <Link to="/login" onClick={onClose} style={{ textDecoration: 'none', display: 'block' }}>
            <div style={{
              display: 'flex', alignItems: 'center', gap: 10,
              padding: '9px 11px', borderRadius: 10,
              background: 'var(--brand-grad)', cursor: 'pointer',
            }}>
              <div style={{ width: 28, height: 28, borderRadius: 7, flexShrink: 0, background: 'rgba(255,255,255,0.22)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 14 }}>👤</div>
              <div>
                <div style={{ fontSize: 12, fontWeight: 700, color: 'white', lineHeight: 1.3 }}>Sign in</div>
                <div style={{ fontSize: 10, color: 'rgba(255,255,255,0.7)' }}>Sync your tasks</div>
              </div>
            </div>
          </Link>
        ) : (
          <div style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '6px 8px', borderRadius: 8, transition: 'background 0.12s' }}
            onMouseEnter={e => e.currentTarget.style.background = 'var(--hover)'}
            onMouseLeave={e => e.currentTarget.style.background = 'transparent'}
          >
            <div style={{ width: 30, height: 30, borderRadius: 9, flexShrink: 0, background: 'var(--brand-grad)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 11, fontWeight: 800, color: 'white' }}>
              {initials}
            </div>
            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={{ fontSize: 12, fontWeight: 600, color: 'var(--text)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', lineHeight: 1.3 }}>{user?.name}</div>
              <div style={{ fontSize: 10, color: 'var(--text3)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{user?.email}</div>
            </div>
            <button onClick={handleLogout} title="Sign out" style={{ background: 'none', border: 'none', cursor: 'pointer', color: 'var(--text3)', padding: '4px', borderRadius: 5, display: 'flex', flexShrink: 0, transition: 'color 0.12s' }}
              onMouseEnter={e => e.currentTarget.style.color = '#EF4444'}
              onMouseLeave={e => e.currentTarget.style.color = 'var(--text3)'}
            ><LogoutIcon /></button>
          </div>
        )}
      </div>
    </aside>
  );
}